<template>
  <multiselect
    :options="sinisterResults"
    track-by="id"
    @search-change="queryChanged"
    :internal-search="false"
    :maxHeight="450"
    :loading="loading"
    v-bind="attrs"
    v-on="$listeners"
  >
    <template slot="noOptions">Sin resultados.</template>

    <template slot="noResult">No hay resultados</template>

    <div slot-scope="{ option }" slot="option">
      <strong>{{ option.sinisterNumber }}</strong>
      <br />

      <div>
        <strong>No. Requisición:</strong>
        {{ option.requisitionNumber }}
      </div>

      <div>
        <strong>Folio JB:</strong>
        {{ option.folioJB | folioFilter }}
      </div>
    </div>
  </multiselect>
</template>

<script>
import sinisterService from "@/services/sinister";
import { debounce } from "lodash";

function folioFilter(folioJB) {
  return folioJB ? folioJB : "Sin folio";
}

const NO_RESULTS_MSG = "No hay resultados";
const EMPTY_MESSAGE = "Escriba un termino de busqueda";
const MIN_LENGTH_QUERY = 2;

const defaultAttrs = {
  placeholder: "Buscar siniestro",
  ["select-label"]: "Enter para ir al siniestro",
};

export default {
  name: "SinisterSelect",

  props: {
    fetchOptions: {
      type: Object,
      required: false,
      default: null,
    },
  },

  data() {
    return {
      sinisterResults: [],
      loading: false,
      searchQuery: "",
    };
  },

  filters: { folioFilter },

  computed: {
    noOptionsMessage() {
      return this.searchQuery ? NO_RESULTS_MSG : EMPTY_MESSAGE;
    },
    attrs() {
      return {
        ...defaultAttrs,
        ...this.$attrs,
      };
    },
  },

  methods: {
    queryChanged: debounce(function (query) {
      this.searchQuery = (query && query.trim()) || "";
      if (this.searchQuery.length < MIN_LENGTH_QUERY) {
        this.loading = false;
        return;
      }
      this.loading = true;
      sinisterService
        .quickSearch(this.searchQuery, this.fetchOptions)
        .then((sinisters) => {
          this.sinisterResults = sinisters;
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
        });
    }, 500),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/SinisterSelect.vue